import { buildRhodeItemsSummary } from "./rhodeCourseAnnouncements";

const firstName = (value) =>
  String(value || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)[0] || "";

export const buildRhodeDispatchAnnouncement = (payload = {}) => {
  const kind = String(payload?.dispatchKind || payload?.dispatch_kind || "")
    .trim()
    .toLowerCase();
  if (!["claim", "addition"].includes(kind)) return "";
  const actor = firstName(
    payload?.dispatchActorName || payload?.serverName || "",
  );
  const courseNumber =
    Number(payload?.courseNumber || payload?.course_number) || 1;
  const tableNumber = payload?.tableNumber || payload?.table || "inconnue";
  const items = Array.isArray(payload?.items) ? payload.items : [];

  if (kind === "claim") {
    const summary = buildRhodeItemsSummary(items, 5) || "un article";
    return `${actor ? `${actor} réclame` : "Réclamation du"} le tour ${courseNumber} de la table ${tableNumber} : ${summary}.`;
  }

  const summary = buildRhodeItemsSummary(items) || "un article";
  return `${actor ? `${actor} a rajouté` : "Rajout de"} ${summary} au tour ${courseNumber} de la table ${tableNumber}.`;
};
